// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1gzST","placeholdersHeader":"styles_placeholdersHeader__EPBGj","editorStyle":"styles_editorStyle__YlAFX","placeholdersBox":"styles_placeholdersBox__3qo23"};